import { render, staticRenderFns } from "./budget-requests.vue?vue&type=template&id=c85867ae"
import script from "./budget-requests.ts?vue&type=script&lang=ts&external"
export * from "./budget-requests.ts?vue&type=script&lang=ts&external"
import style0 from "./budget-requests.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c85867ae')) {
      api.createRecord('c85867ae', component.options)
    } else {
      api.reload('c85867ae', component.options)
    }
    module.hot.accept("./budget-requests.vue?vue&type=template&id=c85867ae", function () {
      api.rerender('c85867ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/budget-requests/budget-requests.vue"
export default component.exports